import React, { useState, useEffect } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import CommonTable from '../components/Common_table'
import SubHeader from '../components/SubHeader'
import { useGlobalContext } from '../../context/Context'
import instance from '../../Utils/api';
import CircularProgress from '@mui/material/CircularProgress';
import Paymentstatus from '../components/Payment_status'
import Viewpayment from '../components/View_payment'
import DownloadExportData from '../../Utils/excel'

const Payment = () => {
    const url = window.location.pathname;
    const title = {
        name: "Payment",
        subheading: "Manage and track your payment transactions seamlessly",
        search: "Search Name",
    }
    const statusOptions = ['None', 'Done', 'Pending', 'Canceled'];
    const paymentForoptions = ['None', 'Order', 'Consultation'];
    const tabsData = [
        {
            label: "All",
            name: "",
            options: []
        },
        {
            label: "Order",
            name: "Order",
            options: ['Order']
        },
        {
            label: "Consultation",
            name: "Consultation",
            options: ['Consultation']
        },
    ]
    const columns = [
        { label: "S.No", field: "sno",  },
        { label: "Name", field: "name",  },
        { label: "Location", field: "location",  },
        // { label: "Category Image", field: "Bannerimage",  },
        { label: "Payment For", field: "for",  },
        { label: "Amount", field: "amount",  }, ,
        { label: "Payment Status", field: "paymentstatus",  },
        { label: "Created Date", field: "createddDate",  },
        { label: "Last Updated Date", field: "UpdatedDate",  },
        ...(url === '/admin/Reports/Payments'
            ? []
            : [{ label: "Actions", field: "action",  }])
    ];
    //usestate define
    const { loading, setLoading } = useGlobalContext();
    const { openviewDialog, setopenviewDialog } = useGlobalContext();
    const { openDialog, setOpenDialog } = useGlobalContext();
    const { statusDialog, setstatusDialog } = useGlobalContext();
    const [payment, setPayment] = useState([]);
    const [getpayment, setgetPayment] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [totalpages, setTotalPages] = useState();
    const [currentPage, setCurrentPages] = useState(1);
    const [totalCount, setTotalcount] = useState();
    const [search, setSearch] = useState();
    const [status, setStatus] = useState();
    const [paymentfor, SetPaymentFor] = useState();
    const [tabSearch, setTabSearch] = useState();
    const rowsperpage = 10;
    const [anchorEl, setAnchorEl] = useState(null); //menu
    const open = Boolean(anchorEl);
    const [download, setDownload] = useState(false);

    //fetch Payments
    const fetchPayments = async (search, currentPage, rowsperpage, download) => {
        const params = {
            search,
            page: currentPage,
            ...(!download ? { limit: rowsperpage } : { limit: totalpages * rowsperpage }),
            limit: rowsperpage,
            // sortBy: "createdAt",
            // sortOrder: "desc",
            ...(status && status !== 'None' ? { status } : {}),
            ...(paymentfor && paymentfor !== 'None' ? { for: paymentfor } : {}),
            ...(tabSearch ? { for: tabSearch } : {}),
            download
        };
        try {
            const response = await instance.get('/Payment/getPayments', { params });
            if (download) {
                DownloadExportData(response.data);
                setDownload(false);
            } else {
                const formatteddata = response?.data?.data?.map((pay, index) => ({
                    sno: index + 1,
                    name: pay?.Customer?.name || '---',
                    location: pay?.Customer?.location,
                    // Bannerimage: pay?.Customer?.profile_pic,
                    for: pay?.for,
                    amount: pay?.amount,
                    paymentstatus: pay?.status,
                    createddDate: new Date(pay?.createdAt).toLocaleString(),
                    UpdatedDate: new Date(pay?.updatedAt).toLocaleString(),
                    paymentId: pay?._id,
                    paymentdata: pay,
                }))

                setPayment(formatteddata);
                setTotalPages(response?.data?.totalPages);
                setCurrentPages(response?.data?.currentPage);
                setTotalcount(response?.data?.total);
            }
        }
        catch (error) {
            console.log("error to fetch payments:", error.message)
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        fetchPayments(search, currentPage, rowsperpage, download)
        setLoading(true);
        setgetPayment(false)
    }, [getpayment, search, currentPage, rowsperpage, download])


    // Handle Row Click for view
    const handleViewClick = (pay) => {
        setSelectedPayment(pay.paymentdata); // Set selected payment data
        setopenviewDialog(true)
    }
    // Handle Row Click for status change
    const handlepaymentstatus = (pay) => {
        setSelectedPayment(pay);
        setstatusDialog(true); // Show the status payment popup
    };

    //filter function open menu
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Menu close handler
    const handleCloseFilter = () => {
        setAnchorEl(null);
        // empty the fields
        // setStatus('');
        // SetPaymentFor('')
    };
    const handleresetCloseFilter = () => {
        // empty the fields
        setStatus('');
        SetPaymentFor('');
        fetchPayments();
        setAnchorEl(null);
    };

    // Apply Filter Handler
    const handlePayApplyFilter = () => {
        fetchPayments();
        handleCloseFilter()
    };

    return (
        <>
            <Topbar />
            <section className='admin-catalogue'>
                <PageHeader
                    title={title}
                    setSearch={setSearch}
                    showButton={false}
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                    files={true}
                    Download={() => setDownload(true)}
                />
                <SubHeader
                    menu={true}
                    filter={true}
                    isVisible={true}
                    isPaymentPage={true}
                    tabsData={tabsData}
                    statusOptions={statusOptions}
                    paymentForoptions={paymentForoptions}
                    setTabSearch={setTabSearch}
                    tabSearch={tabSearch}
                    status={status}
                    setStatus={setStatus}
                    paymentfor={paymentfor}
                    SetPaymentFor={SetPaymentFor}
                    anchorEl={anchorEl}
                    open={open}
                    handleClick={handleClick}
                    handleCloseFilter={handleCloseFilter}
                    handlePayApplyFilter={handlePayApplyFilter}
                    handleresetCloseFilter={handleresetCloseFilter}
                />
                {loading ?
                    <CircularProgress />
                    :
                    <CommonTable
                        columns={columns}
                        rows={payment}
                        paymentstatus={false}
                        banner={true}
                        showPagination={false}
                        handleViewClick={handleViewClick}
                        handlepaymentstatus={handlepaymentstatus}
                        totalpages={totalpages}
                        rowsperpage={rowsperpage}
                        totalCount={totalCount}
                        currentPage={currentPage}
                        setCurrentPages={setCurrentPages}
                    />
                }
                <Viewpayment
                    openviewDialog={openviewDialog}
                    setopenviewDialog={setopenviewDialog}
                    selectedPayment={selectedPayment}
                />
                <Paymentstatus
                    statusDialog={statusDialog}
                    setstatusDialog={setstatusDialog}
                    selectedPayment={selectedPayment}
                    setgetPayment={setgetPayment}
                />
            </section>
        </>
    )
}

export default Payment;
